module.exports = __webpack_public_path__ + "static/media/font.2e926005.svg";